"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameNavBar = GameNavBar;
const React = __importStar(require("react"));
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_jss_1 = require("react-jss");
const react_redux_1 = require("react-redux");
const NavBar_1 = require("~/components/ui/navbar/NavBar");
const players_1 = require("~/store/game/players");
const ui_1 = require("~/store/game/ui");
const NavItemShop_1 = require("./NavItemShop");
const useStyles = (0, react_jss_1.createUseStyles)({
    navBar: {
        display: "flex",
        flexDirection: "row",
    },
});
const navBarItems = [
    { key: "players", icon: free_solid_svg_icons_1.faUsers },
    { key: "shop", icon: free_solid_svg_icons_1.faShoppingCart, children: React.createElement(NavItemShop_1.NavItemShop, null) },
    { key: "stats", icon: free_solid_svg_icons_1.faChartColumn },
    { key: "settings", icon: free_solid_svg_icons_1.faQuestionCircle },
];
function getOverlayKey(overlay) {
    switch (overlay) {
        case ui_1.Overlay.PLAYERS:
            return "players";
        case ui_1.Overlay.SHOP:
            return "shop";
        case ui_1.Overlay.STATS:
            return "stats";
        case ui_1.Overlay.SETTINGS:
            return "settings";
        default:
            return null;
    }
}
function getKeyOverlay(key) {
    switch (key) {
        case "players":
            return ui_1.Overlay.PLAYERS;
        case "shop":
            return ui_1.Overlay.SHOP;
        case "stats":
            return ui_1.Overlay.STATS;
        case "settings":
            return ui_1.Overlay.SETTINGS;
        default:
            return null;
    }
}
function GameNavBar() {
    var _a;
    const styles = useStyles();
    const dispatch = (0, react_redux_1.useDispatch)();
    const activeOverlay = (0, react_redux_1.useSelector)((state) => state.game.ui.currentOverlay);
    const canUseShop = ((_a = (0, players_1.useLocalPlayer)()) === null || _a === void 0 ? void 0 : _a.health) !== 0;
    const isSpectating = (0, react_redux_1.useSelector)((state) => state.game.spectating.id !== null);
    const onClick = (key) => {
        if (key === getOverlayKey(activeOverlay)) {
            dispatch((0, ui_1.closeOverlay)());
            return;
        }
        if (key === "shop") {
            if (!canUseShop || isSpectating) {
                return;
            }
        }
        const overlay = getKeyOverlay(key);
        if (overlay === null) {
            return;
        }
        dispatch((0, ui_1.openOverlay)(overlay));
    };
    return (React.createElement(NavBar_1.NavBar, { items: navBarItems, active: getOverlayKey(activeOverlay), onSelect: onClick }));
}
